/**
 * Whether ChatView should ask the AI SDK to attempt resuming an in-progress
 * stream (`useChat`'s `resume` option).
 *
 * Must stay false until persisted chat history has finished loading and the
 * Supabase access token is ready — resumeStream() snapshots off whatever is
 * currently in SDK message state and sends the reconnect request with
 * whatever token is on hand *at that instant*. Firing it before either is
 * ready either wipes/races against the persisted-history fetch (see
 * chat-view.tsx's history-load effect) or gets silently 204'd by the server
 * for a missing Authorization header, so this must gate `resume` rather than
 * be reactive concurrently with it.
 */
export function shouldEnableStreamResume({
  hasChatIdentity,
  incognito,
  historyLoaded,
  accessTokenReady,
}: {
  hasChatIdentity: boolean;
  incognito: boolean;
  historyLoaded: boolean;
  accessTokenReady: boolean;
}): boolean {
  return hasChatIdentity && !incognito && historyLoaded && accessTokenReady;
}
